import { Box } from '@mui/material';

import Logo from '@/shared/ui/icons/Logo.svg';

/**
 * Загрузочный экран приложения
 */
export const SplashScreen = () => {
  return (
    <Box justifyContent='center' alignItems='center' flex={1} display='flex'>
      <Logo />
    </Box>
  );
};
